const cwsAccordion = (el, box, item) => {
  const openBtn = document.querySelectorAll(el);

  openBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      const symbol = btn.querySelector("span");
      const parent = btn.closest(box);
      const txt = parent.querySelector(item);
      const active = "active";

      if (parent.classList.contains(active)) {
        parent.classList.remove(active);
        symbol.textContent = "+";

        if (txt !== null) {
          txt.style.height = 0;
        }
      } else {
        parent.classList.add(active);
        symbol.textContent = "-";

        if (txt !== null) {
          txt.style.height = `${txt.scrollHeight}px`;
        }
      }
    });
  });
};

const faqPage = () => {
  const faqGlobalLinks = document.querySelectorAll(".faq-sidebar ul a");
  const faqGlobalBoxes = document.querySelectorAll(".faq-box");
  const activeClass = "active";

  faqGlobalLinks.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();

      item
        .closest("ul")
        .querySelector(`li.${activeClass}`)
        .classList.remove(activeClass);
      item.closest("li").classList.add(activeClass);

      faqGlobalBoxes.forEach((box) => {
        box.classList.remove(activeClass);

        if (box.getAttribute("id").indexOf(item.getAttribute("href")) > -1) {
          box.classList.add(activeClass);
        }
      });

      window.location.hash = item.getAttribute("href");
    });
  });

  const checkHash = (txt, el) => {
    const links = document.querySelectorAll(el);

    if (window.location.href.indexOf(txt) > -1 && window.location.hash.length) {
      const hash = window.location.hash.replace("#", "");

      links.forEach((link) => {
        if (link.getAttribute("href").indexOf(hash) > -1) {
          link.click();
        }
      });
    }
  };

  checkHash("faq", ".faq-sidebar ul a");
};

cwsAccordion(".faq__open", ".faq__item", ".faq__txt");
faqPage();
